module.exports = __webpack_public_path__ + "ba.svg?08574dd3e584a45c50c666908c63f124";